import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuthStore } from "../../store/authStore";
import { Spinner } from "../UI/Spinner";

interface Props {
  children: ReactNode;
  requireRoles?: Array<"ADMIN" | "TECHNICIAN" | "VIEWER">;
}

export function ProtectedRoute({ children, requireRoles }: Props) {
  const { user, accessToken, isHydrating } = useAuthStore();
  const location = useLocation();

  if (isHydrating) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner size={40} />
      </div>
    );
  }

  if (!accessToken || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireRoles && !requireRoles.includes(user.role)) {
    return <Navigate to="/plans" replace />;
  }

  return <>{children}</>;
}
